var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-dialog',{attrs:{"text":"Parameter Alert","show-dialog":_vm.showDialog,"on-close":_vm.handleClose,"width":850}},[(_vm.showDialog)?[_c('asc-parameter-alert',{attrs:{"definition":_vm.definition,"loading":_vm.loading}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }